export const VIDEO_TYPES = 'video/mp4, video/mov';
export const IMAGE_TYPES = 'image/png, image/jpeg, image/jpg';
